import { render, staticRenderFns } from "./comments-dialog.vue?vue&type=template&id=50677148&scoped=true"
import script from "./comments-dialog.vue?vue&type=script&lang=js"
export * from "./comments-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50677148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50677148')) {
      api.createRecord('50677148', component.options)
    } else {
      api.reload('50677148', component.options)
    }
    module.hot.accept("./comments-dialog.vue?vue&type=template&id=50677148&scoped=true", function () {
      api.rerender('50677148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/shared/components/comments-dialog.vue"
export default component.exports